import { render, staticRenderFns } from "./PvcPoster.vue?vue&type=template&id=740b739c&scoped=true&"
import script from "./PvcPoster.vue?vue&type=script&lang=js&"
export * from "./PvcPoster.vue?vue&type=script&lang=js&"
import style0 from "./PvcPoster.vue?vue&type=style&index=0&id=740b739c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740b739c",
  null
  
)

component.options.__file = "PvcPoster.vue"
export default component.exports